import { FetchAPI } from "./main";

export const JobsAPI = {
  getJobs: (data) => {
    const {
      userId,
      status,
      page,
      pageSize,
      employmentType,
      searchString,
      location,
      orderBy,
      direction,
    } = data;
    const query = new URLSearchParams();

    query.set("page", page);
    query.set("pageSize", pageSize);
    if (!!userId) query.set("userId", userId);
    if (!!status) query.set("status", status);
    if (!!employmentType) query.set("employmentType", employmentType);
    if (!!searchString) query.set("searchString", searchString);
    if (!!location) query.set("location", location);
    if (!!orderBy) query.set("orderBy", orderBy);
    if (!!direction) query.set("direction", direction);
    return FetchAPI.getJson(`/jobs?${query.toString()}`);
  },
  suggestJob: (data) => FetchAPI.postJson(`/jobs`, { ...data, suggest: true }),
  getJob: (id) => FetchAPI.getJson(`/jobs/${id}`),
  getStatuses: () => FetchAPI.getJson(`/jobs/statuses`),
  getLocations: () => FetchAPI.getJson(`/jobs/locations`),
  getEmploymentTypes: () => FetchAPI.getJson(`/jobs/employment-types`),
};
